import {DIRECTION} from "../../common/constants";

export const ERROR_COLOR = "#D0021B";

export const LIGHT_TEXT_COLOR = "#aaa";
export const BUY_COLOR = "#00acf0";
export const SELL_COLOR = "#ec6b10";
export const TEXT_COLOR = "#28313E";


export const colorForDirection = (direction) => {
    switch (direction) {
        case (DIRECTION.BUY):
            return BUY_COLOR;
        case (DIRECTION.SELL):
            return SELL_COLOR;
        default:
            return TEXT_COLOR;
    }
};


/** WEBPACK FOOTER **
 ** ./src/main/javascript/disclosure/common/styles.js
 **/